import KeyMirror from "keymirror"

export const dialogTypes = KeyMirror({
    LESSON: null,
    LESSON_COPY: null,
    LESSON_MATERIAL: null,
    TASK: null,
    FILTER: null,
    PLAN: null,
})

export const dialogModes = KeyMirror({
    VIEW: null,
    CREATE: null,
    UPDATE: null,
    DELETE: null,
})

export const userRoleLookups = {
    учитель: "employee",
    ученик: "student",
}

export const initialValues = {
    lesson: {
        id: null,
        date: new Date().toISOString().slice(0, 16),
        duration: 40,
        subject: null,
        group: null,
        studio: null,
    },
    logBookItem: {
        id: null,
        is_attending: false,
        mark: null,
    },
    task: {
        name: "",
        task_text: "",
    },
    lessonMaterial: {
        name: "",
        comment: "",
    }
}